/* eslint-disable-next-line @fluentui/react-components/prefer-fluentui-v9 -- (https://aka.ms/OWALintWiki)
 * Baseline. DO NOT COPY AND PASTE! Substitute this line with an explanation or resolve the problem by using v9 components instead
 *	> Avoid using Icon from '@fluentui/react', as this package has already migrated to Fluent UI 9. Use a JSX SVG icon from '@fluentui/react-icons' instead. */
import { Icon } from '@fluentui/react/lib/Icon';
import classnames from 'owa-classnames';
import { observer } from 'owa-mobx-react';
import { getDensityModeCssClass, getIsDarkTheme } from 'owa-fabric-theme';
import type CategoryType from 'owa-service/lib/contract/CategoryType';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import React from 'react';
import {
    categorySizeFull,
    categorySizeMediumOrCompact,
    categorySizeCompact,
    categorySizeFullOrMedium,
} from '../scss/CategorySharedStyles.scss';
import getCategoryColorsForCategory, {
    getDefaultCategoryColor,
} from '../utils/getCategoryColorsForCategory';
import getMasterCategoryList from '../utils/getMasterCategoryList';
import type { MailboxInfo } from 'owa-client-types';
import { lightColorCodeValueMap } from '../store/helpers/getLightThemeColorCodeValueMap';
import { darkColorCodeValueMap } from '../store/helpers/getDarkThemeColorCodeValueMap';
import { TagDuoToneIcon, getDuoToneIconStyles } from './TagDuoToneIcon';
import { categoryIconV9Style, categoryIconV9StyleNoTextShadow } from './CategoryMenu.scss';

export interface CategoryIconProps {
    categoryName?: string;
    categoryList?: CategoryType[];
    categoryColorId?: string;
    mailboxInfo?: MailboxInfo;
    iconClassName: string;
}

const CategoryIcon: React.FunctionComponent<CategoryIconProps> = observer(function CategoryIcon(
    props: CategoryIconProps
) {
    let categoryColor;
    let categoryColorId;

    /**
     * Try to get category color from the category name
     * If the name is not specified (in case of new category creation) check if color id is specified and get color from the colorValueMap
     * Else use the default color
     */
    if (props.categoryName && props.mailboxInfo) {
        const categoryList = props.categoryList
            ? props.categoryList
            : getMasterCategoryList(props.mailboxInfo);

        categoryColor = getCategoryColorsForCategory(
            props.categoryName,
            categoryList,
            props.mailboxInfo
        );
        // Get category color id from the category list. Find category based on category name
        const category = categoryList?.find(
            cat => cat.Name?.toLowerCase() === props.categoryName?.toLowerCase()
        );
        // Extract the color from the category
        categoryColorId = category?.Color;
    } else if (props.categoryColorId) {
        categoryColor = getIsDarkTheme()
            ? darkColorCodeValueMap[props.categoryColorId]
            : lightColorCodeValueMap[props.categoryColorId];
    } else {
        categoryColor = getDefaultCategoryColor();
    }

    const getIconStyles = getDuoToneIconStyles(categoryColor);

    const isDenselessEnabled = isGlobalFeatureEnabled('rp-denseless');

    const iconClass = classnames(
        props.iconClassName,
        getDensityModeCssClass(
            isDenselessEnabled ? categorySizeFullOrMedium : categorySizeFull,
            isDenselessEnabled ? categorySizeFullOrMedium : categorySizeMediumOrCompact,
            isDenselessEnabled ? categorySizeCompact : categorySizeMediumOrCompact
        ),
        //No text shadow for None category
        categoryColorId === -1 || props.categoryColorId == '-1'
            ? categoryIconV9StyleNoTextShadow
            : categoryIconV9Style
    );

    const iconFilledProperties = {
        iconName: TagDuoToneIcon,
        className: iconClass,
        styles: {
            root: getIconStyles,
        },
    };

    return <Icon {...iconFilledProperties} />;
},
'CategoryIcon');
export default CategoryIcon;
